import { type Params, type UIMatch, useMatches } from "react-router-dom"

export type ICommonSearchParams = "requestId" | "id" | "programId" | "contractId"

export type BreadcrumbHandle = {
  label: string
  i18Key?: string
  paramKey?: string
  paramCallback?: (params?: Readonly<Params<string>>) => string
  keepSearchParams?: (string | ICommonSearchParams)[]
}

export const useRouteMatch = (): UIMatch<unknown, BreadcrumbHandle>[] => {
  return useMatches() as UIMatch<unknown, BreadcrumbHandle>[]
}
